import React, { useState } from 'react';
import { observer } from 'mobx-react';
import type OrderItem from '@this/domain/order_item2';
import { Fetcher } from '@this/src/util';

interface Props {
  orderItem: OrderItem;
}

export const OrderItemWaitingSelect = observer(({ orderItem }: Props) => {
  const [saving, setSaving] = useState(false);

  const handleChange = (value: boolean) => {
    setSaving(true);
    Fetcher.put(`/arrangement/order_items/${orderItem.id}/update_waiting`, { waiting: value })
      .then(() => {
        orderItem.waiting = value;
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: '5px' }}>引き継ぎ:</span>
      {saving ? (
        <span>保存中...</span>
      ) : (
        <select
          onChange={e => handleChange(e.target.value === 'true')}
          value={orderItem.waiting?.toString() ?? 'false'}
          style={{ marginBottom: '0px' }}
        >
          <option value="true">◯</option>
          <option value="false">×</option>
        </select>
      )}
    </div>
  );
});
